var map = {
	"./treatments-directory-dashboard-mobile-en.jpg": "1ea0",
	"./treatments-directory-dashboard-mobile-fr.jpg": "d999",
	"./treatments-directory-dashboard-mobile-ru.jpg": "b881"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b62c";